"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMALLEST_ADVANCE_AMOUNT = void 0;
exports.advanceIsEnterable = advanceIsEnterable;
const money_1 = require("./money");
// The smallest figure an advance can state. Money carries MONEY_SCALE decimals while the advance
// form states PRINT_SCALE, so a remainder below this floor has no advance that can represent it.
// The form and the close condition both read the floor from here, so they cannot disagree on which
// remainder is still recordable.
exports.SMALLEST_ADVANCE_AMOUNT = (0, money_1.toMoney)(`0.${'0'.repeat(money_1.PRINT_SCALE - 1)}1`);
function advanceIsEnterable(value) {
    return (0, money_1.isMoney)(value) && (0, money_1.compareMoney)(value, exports.SMALLEST_ADVANCE_AMOUNT) >= 0;
}
//# sourceMappingURL=advance-amount.js.map